import { useMemo } from 'react';
import BooleanCell from 'components/shared/Table/TableCell/DataGrid/BooleanCell';
import { GridColDef } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';

export const useColumnDefinitions = () => {
  const { t } = useTranslation();
  return useMemo<GridColDef[]>(
    () => [
      {
        field: 'claCode',
        headerName: t('adminPortal.claMaintenance.code'),
        hideable: false,
        minWidth: 120,
        flex: 1
      },
      {
        field: 'name',
        headerName: t('adminPortal.claMaintenance.name'),
        hideable: false,
        minWidth: 160,
        flex: 1
      },
      {
        field: 'claExt',
        headerName: t('adminPortal.claMaintenance.externalCode'),
        hideable: false,
        minWidth: 160,
        flex: 1
      },
      {
        field: 'isDefault',
        headerName: t('adminPortal.claMaintenance.importDefault'),
        type: 'boolean',
        hideable: false,
        minWidth: 160,
        renderCell: BooleanCell
      }
    ],
    [t]
  );
};
